/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Still_Salty_Marlin_ChopInputs */

const fr_still_salty_marlin_chop = /** @type {(inputs: Still_Salty_Marlin_ChopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Après-midi`)
};

/**

* @param {Still_Salty_Marlin_ChopInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const still_salty_marlin_chop = /** @type {((inputs?: Still_Salty_Marlin_ChopInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Still_Salty_Marlin_ChopInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_still_salty_marlin_chop(inputs)
});